import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_KEY } from 'appConstants';

// Loaded once for the whole app; Elements must always get the same promise.
const stripePromise = loadStripe(STRIPE_KEY);

// The card field renders in Stripe's iframe, so the portal's font has to be passed in.
const fonts = [{ cssSrc: 'https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap' }];

export const CardPaymentElements = ({ children }: { children: React.ReactNode }) => (
  <Elements stripe={stripePromise} options={{ fonts }}>
    {children}
  </Elements>
);
